export enum FilterTableWalletEnum {
   ALL = "NULL",
   IN = "TOPUP",
   OUT = "PAYMENT",
   NONE = "",
}
